import Color from 'color'

// default threshold is set to 60, because we want to consider #26B9FFFF as dark color
const defaultThreshold = 60
export const isColorDark = (hex, threshold = defaultThreshold) => {
  let lightness = Color(hex).lightness()

  return lightness <= threshold
}
